<template>
  <div class="recipient-creator">
    <strong>{{ title }}:</strong>
    <span v-if="recipients.length > 0">
      <span v-bind:key="i" v-for="(recipient, i) in recipients">
        <b-badge variant="primary" class="rounded-pill">{{ recipient }} <i class="fa fa-close cursor-pointer" @click="removeRecipient(i)"></i></b-badge>&nbsp;
      </span>
    </span>
    <span v-else><i>--brak--</i></span>
    <b-input-group>
      <b-form-input ref="recipient" v-model="newRecipient" @click="input" @keyup.enter="appendRecipient()" @focusout="appendRecipient()" @select="input"/>
      <b-button variant="primary" @click="appendRecipient()"><i class="fa fa-plus"></i> </b-button>
    </b-input-group>
  </div>
</template>
<script>

import inputHelper from '../../inputHelper'
import variablesHelper from '../variablesHelper'
import emailValidator from '../../emailValidator'

export default {
  props: ['title', 'initRecipients'],
  components: {},
  data () {
    return {
      currentInput: null,
      newRecipient: null,
      recipients: this.initializeRecipients()
    }
  },
  name: 'c-email-recipient-creator',
  methods: {
    initializeRecipients () {
      if (this.initRecipients) {
        return JSON.parse(JSON.stringify(this.initRecipients))
      }
      return []
    },
    async copyVariable (variable) {
      if (!this.currentInput) return
      inputHelper.copyTextToInput(this.currentInput, variable)
    },
    appendRecipient () {
      this.newRecipient = this.newRecipient.trim()
      if (this.newRecipient === '') {
        return
      }

      if (!this.isEmailValid(this.newRecipient) && !variablesHelper.isVariable(this.newRecipient)) {
        this.$notify({ group: 'notify', type: 'warn', title: 'Nieprawidłowy format adresu email', text: '' })
        return
      }

      this.recipients.push(this.newRecipient)
      this.$emit('changed', this.recipients)
      this.newRecipient = null
    },
    removeRecipient (index) {
      this.recipients.splice(index, 1)
      this.$emit('changed', this.recipients)
    },
    input () {
      this.$emit('input', this.$refs.recipient)
    },
    isEmailValid (email) {
      return emailValidator.isValid(email)
    }
  }
}
</script>
